export type MarkdownParsedNodeType = 'text' | 'b';

export interface MarkdownParsedNode {
  type: MarkdownParsedNodeType;
  value: string;
}

export class MarkdownParser {
  static parse(text: string): Array<MarkdownParsedNode> {
    const nodes: Array<MarkdownParsedNode> = [];
    let lastIndex = 0;
    const boldRegex = /\*\*([^*]+)\*\*/g; // Matches **bold text**

    let match;
    while ((match = boldRegex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        nodes.push({ type: 'text', value: text.substring(lastIndex, match.index) });
      }
      nodes.push({ type: 'b', value: match[1] ?? '' }); // match[1] is the text inside ** **
      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length) {
      nodes.push({ type: 'text', value: text.substring(lastIndex) });
    }

    return nodes;
  }
}
